"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CancellationReasonView = void 0;
const util_1 = require("../util");
const typeorm_1 = require("typeorm/browser");
const cancellation_reason_1 = require("./cancellation-reason");
const cancellation_reason_enums_1 = require("./cancellation-reason-enums");
let CancellationReasonView = class CancellationReasonView {
};
__decorate([
    (0, typeorm_1.Column)('integer', {
        name: 'id',
    }),
    __metadata("design:type", Number)
], CancellationReasonView.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        name: 'name',
        length: 64,
    }),
    __metadata("design:type", String)
], CancellationReasonView.prototype, "name", void 0);
__decorate([
    (0, typeorm_1.Column)('integer', {
        name: 'cancellation_reason_id__c',
    }),
    __metadata("design:type", Number)
], CancellationReasonView.prototype, "cancellationReasonId", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        name: 'cancellation_reason_category__c',
        length: 128,
    }),
    __metadata("design:type", String)
], CancellationReasonView.prototype, "category", void 0);
__decorate([
    (0, typeorm_1.Column)('double precision', {
        name: 'price_storno_percent__c',
    }),
    __metadata("design:type", Number)
], CancellationReasonView.prototype, "stornoPercent", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        name: 'on_top_or_alternative__c',
        length: 64,
    }),
    __metadata("design:type", String)
], CancellationReasonView.prototype, "onTopOrAlternative", void 0);
__decorate([
    (0, typeorm_1.Column)('double precision', {
        name: 'show_from__c',
    }),
    __metadata("design:type", Number)
], CancellationReasonView.prototype, "showFrom", void 0);
__decorate([
    (0, typeorm_1.Column)('double precision', {
        name: 'show_until__c',
    }),
    __metadata("design:type", Number)
], CancellationReasonView.prototype, "showUntil", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        name: 'dokumentationstyp__c',
        length: 128,
    }),
    __metadata("design:type", String)
], CancellationReasonView.prototype, "documentationType", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: cancellation_reason_enums_1.CancellationReasonDateFieldsEnum,
        nullable: false,
        default: cancellation_reason_enums_1.CancellationReasonDateFieldsEnum.READ_ONLY,
        name: 'delivery_date_show',
    }),
    __metadata("design:type", String)
], CancellationReasonView.prototype, "deliveryDateShow", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: cancellation_reason_enums_1.CancellationReasonDateFieldsEnum,
        nullable: false,
        default: cancellation_reason_enums_1.CancellationReasonDateFieldsEnum.READ_ONLY,
        name: 'readiness_date_show',
    }),
    __metadata("design:type", String)
], CancellationReasonView.prototype, "readinessDateShow", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: cancellation_reason_enums_1.CancellationReasonDateFieldsEnum,
        nullable: false,
        default: cancellation_reason_enums_1.CancellationReasonDateFieldsEnum.READ_ONLY,
        name: 'appointment_date_show',
    }),
    __metadata("design:type", String)
], CancellationReasonView.prototype, "appointmentDateShow", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        name: 'opportunityid__c',
        length: 18,
    }),
    __metadata("design:type", String)
], CancellationReasonView.prototype, "opportunityId", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        name: 'forces_result__c',
        length: 64,
    }),
    __metadata("design:type", String)
], CancellationReasonView.prototype, "forcesResult", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        name: 'forces_status__c',
        length: 64,
    }),
    __metadata("design:type", String)
], CancellationReasonView.prototype, "forcesStatus", void 0);
__decorate([
    (0, typeorm_1.Column)('boolean', {
        name: 'sign_off__c',
    }),
    __metadata("design:type", Boolean)
], CancellationReasonView.prototype, "signOff", void 0);
__decorate([
    (0, typeorm_1.Column)('text', {
        name: 'description',
    }),
    __metadata("design:type", String)
], CancellationReasonView.prototype, "description", void 0);
__decorate([
    (0, typeorm_1.Column)('text', {
        name: 'customer_description',
    }),
    __metadata("design:type", String)
], CancellationReasonView.prototype, "customerDescription", void 0);
__decorate([
    (0, typeorm_1.Column)('text', {
        name: 'label',
    }),
    __metadata("design:type", String)
], CancellationReasonView.prototype, "label", void 0);
__decorate([
    (0, typeorm_1.Column)('text', {
        name: 'explanation',
    }),
    __metadata("design:type", String)
], CancellationReasonView.prototype, "explanation", void 0);
__decorate([
    (0, typeorm_1.Column)('text', {
        name: 'instructions',
    }),
    __metadata("design:type", String)
], CancellationReasonView.prototype, "instructions", void 0);
__decorate([
    (0, typeorm_1.Column)('text', {
        name: 'source__c',
    }),
    __metadata("design:type", String)
], CancellationReasonView.prototype, "source", void 0);
__decorate([
    (0, typeorm_1.Column)('text', {
        name: 'visible_for__c',
    }),
    __metadata("design:type", String)
], CancellationReasonView.prototype, "visibleFor", void 0);
__decorate([
    (0, typeorm_1.Column)('text', {
        name: 'available_for_status__c',
    }),
    __metadata("design:type", String)
], CancellationReasonView.prototype, "availableForStatus", void 0);
__decorate([
    (0, typeorm_1.Column)('boolean', {
        name: 'customer_communication__c',
    }),
    __metadata("design:type", Boolean)
], CancellationReasonView.prototype, "customerCommunication", void 0);
__decorate([
    (0, typeorm_1.Column)('boolean', {
        name: 'brand_communication',
    }),
    __metadata("design:type", Boolean)
], CancellationReasonView.prototype, "brandCommunication", void 0);
__decorate([
    (0, typeorm_1.Column)('boolean', {
        name: 'partner_communication',
    }),
    __metadata("design:type", Boolean)
], CancellationReasonView.prototype, "partnerCommunication", void 0);
__decorate([
    (0, typeorm_1.CreateDateColumn)({
        type: 'timestamp with time zone',
    }),
    __metadata("design:type", Date)
], CancellationReasonView.prototype, "createdAt", void 0);
__decorate([
    (0, typeorm_1.UpdateDateColumn)({
        type: 'timestamp with time zone',
    }),
    __metadata("design:type", Date)
], CancellationReasonView.prototype, "updatedAt", void 0);
__decorate([
    (0, typeorm_1.Column)('boolean', {
        name: 'isdeleted',
    }),
    __metadata("design:type", Boolean)
], CancellationReasonView.prototype, "isDeleted", void 0);
CancellationReasonView = __decorate([
    (0, typeorm_1.ViewEntity)({
        expression: (connection) => {
            let qb = connection
                .createQueryBuilder()
                .select('(cr_ext.cro).id', 'id')
                .addSelect('(cr_ext.cr).id', 'cancellation_reason_id__c')
                .addSelect('(cr_ext.cro).opportunity_id', 'opportunityid__c')
                .addSelect('(cr_ext.cr).name', 'name')
                .addSelect('(cr_ext.cr).category', 'cancellation_reason_category__c')
                .addSelect('(cr_ext.cro).storno_percent', 'price_storno_percent__c')
                .addSelect('(cr_ext.cro).on_top_or_alternative::text', 'on_top_or_alternative__c')
                .addSelect(`(cr_ext.cro).customer_communication`, 'customer_communication__c')
                .addSelect(`(cr_ext.cro).brand_communication`, 'brand_communication')
                .addSelect(`(cr_ext.cro).partner_communication`, 'partner_communication')
                .addSelect('(cr_ext.cr).show_from', 'show_from__c')
                .addSelect('(cr_ext.cr).show_until', 'show_until__c')
                .addSelect('(cr_ext.cr).documentation_type::text', 'dokumentationstyp__c')
                .addSelect('(cr_ext.cr).forces_result::text', 'forces_result__c')
                .addSelect('(cr_ext.cr).forces_status::text', 'forces_status__c')
                .addSelect('(cr_ext.cr).sign_off', 'sign_off__c')
                .addSelect('(cr_ext.cr).delivery_date_show', 'delivery_date_show')
                .addSelect('(cr_ext.cr).readiness_date_show', 'readiness_date_show')
                .addSelect('(cr_ext.cr).appointment_date_show', 'appointment_date_show')
                .addSelect('description')
                .addSelect('customer_description')
                .addSelect('label')
                .addSelect('explanation')
                .addSelect('instructions')
                .addSelect(`
          CASE
              WHEN (cr_ext.cr).source IS NULL THEN NULL
              ELSE ARRAY_TO_STRING((cr_ext.cr).source::text[], ';')
          END
      `, 'source__c')
                .addSelect(`
          CASE
              WHEN (cr_ext.cr).visible_for IS NULL THEN NULL
              ELSE ARRAY_TO_STRING((cr_ext.cr).visible_for::text[], ';')
          END
      `, 'visible_for__c')
                .addSelect(`
          CASE
              WHEN (cr_ext.cr).available_for_status IS NULL THEN NULL
              ELSE ARRAY_TO_STRING((cr_ext.cr).available_for_status::text[], ';')
          END
      `, 'available_for_status__c')
                .addSelect('(cr_ext.cr).created_at', 'created_at')
                .addSelect('(cr_ext.cr).updated_at', 'updated_at')
                .addSelect('(cr_ext.cro).deleted_at IS NOT NULL', 'isdeleted')
                .from((subQuery) => {
                return subQuery
                    .select('cr, cro')
                    .addSelect(`
            (
              json_object_agg(
                crl.locale,
                (
                  select crl_int.description
                  from (values (crl.description, crl.locale)) as crl_int(description, locale)
                )
              )
            )
          `, 'description')
                    .addSelect(`
            (
              json_object_agg(
                crl.locale,
                (
                  select crl_int.customer_description
                  from (values (crl.customer_description, crl.locale)) as crl_int(customer_description, locale)
                )
              )
            )
          `, 'customer_description')
                    .addSelect(`
            (
              json_object_agg(
                crl.locale,
                (
                  select crl_int.label
                  from (values (crl.label, crl.locale)) as crl_int(label, locale)
                )
              )
            )
          `, 'label')
                    .addSelect(`
            (
              json_object_agg(
                crl.locale,
                (
                  select crl_int.explanation
                  from (values (crl.explanation, crl.locale)) as crl_int(explanation, locale)
                )
              )
            )
          `, 'explanation')
                    .addSelect(`
            (
              json_object_agg(
                crl.locale,
                (
                  select crl_int.instructions
                  from (values (crl.instructions, crl.locale)) as crl_int(instructions, locale)
                )
              )
            )
          `, 'instructions')
                    .from(cancellation_reason_1.CancellationReason, 'cr')
                    .innerJoin(cancellation_reason_1.CancellationReasonLang, 'crl', '(crl.cancellation_reason_id = cr.id)')
                    .leftJoin(cancellation_reason_1.CancellationReasonOpportunity, 'cro', '(cro.cancellation_reason_id = cr.id)')
                    .groupBy('cr, cro');
            }, 'cr_ext');
            const viewVersion = (0, util_1.getViewVersion)(qb, [
                cancellation_reason_1.CancellationReason,
                cancellation_reason_1.CancellationReasonLang,
                cancellation_reason_1.CancellationReasonOpportunity,
            ], connection);
            qb.addSelect(`'${viewVersion.hash}'`, '__ddl_version');
            return qb;
        },
    })
], CancellationReasonView);
exports.CancellationReasonView = CancellationReasonView;
//# sourceMappingURL=cancellation-reason-view.js.map